export const getButtonText = ({
  isDealRent,
  isNewbuildingFromBuilder,
}: {
  isDealRent: boolean;
  isNewbuildingFromBuilder: boolean;
}): string => {
  if (isDealRent) {
    return 'Назначить просмотр';
  } else if (isNewbuildingFromBuilder) {
    return 'Контакты застройщика';
  }

  return 'Показать телефон';
};
